import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Statistic2NavigationTabsComponent } from '@fi-app/statistic2/statistic2-header/statistic2-navigation-tabs.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiTabsModule } from '@fi-app/utilities/tabs/tabs.module';
import { FiStateSrefModule } from '@fi-app/shared/fi-state-proxy/state-sref/state-sref.module';
import { UIRouterModule } from '@uirouter/angular';
import { MatButtonModule } from '@angular/material/button';
import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { Statistic2HeaderAddReportComponent } from './statistic2-header-add-report/statistic2-header-add-report.component';
import { Statistic2AddExistingReportDialogComponent } from './statistic2-add-existing-report-dialog/statistic2-add-existing-report-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        UIRouterModule,
        FiAppTextSharedModule,
        FiStateSrefModule,
        FiTabsModule,
        ItemsListModule,
    ],
    declarations: [
        Statistic2NavigationTabsComponent,
        Statistic2HeaderAddReportComponent,
        Statistic2AddExistingReportDialogComponent,
    ],
    exports: [Statistic2NavigationTabsComponent],
})
export class Statistic2HeaderModule {}
